import { Check } from "lucide-react";
import { BUSINESS_SERVICES, IMAGES } from "../../data/site";

export const Business = () => (
    <section id="business" data-testid="business-section" className="bg-[#eff6ff]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 md:py-16">
            <div className="grid lg:grid-cols-5 gap-10 items-center">
                <div className="lg:col-span-3">
                    <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-[#0F2E52] mb-3">
                        Local IT Support for Semaphore Businesses
                    </h2>
                    <p className="text-base md:text-lg leading-relaxed text-slate-700 mb-4">
                        We also provide onsite and remote IT support for small businesses. Services can include:
                    </p>
                    <ul
                        className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2.5 mb-5"
                        data-testid="business-services-list"
                    >
                        {BUSINESS_SERVICES.map((item) => (
                            <li key={item} className="flex items-start gap-2 text-sm md:text-base text-slate-700">
                                <Check className="w-4 h-4 text-blue-600 shrink-0 mt-1" />
                                {item}
                            </li>
                        ))}
                    </ul>
                    <p className="text-sm leading-relaxed text-slate-500">
                        For larger or specialist business projects, services are delivered through Tech Emergency and
                        its technology partners.
                    </p>
                </div>
                <div className="lg:col-span-2 relative">
                    <div className="absolute -top-3 -left-3 w-full h-full bg-white rounded-3xl" aria-hidden="true" />
                    <img
                        src={IMAGES.business}
                        alt="Friendly IT support being provided in a small local business office"
                        data-testid="business-image"
                        className="relative rounded-2xl w-full object-cover aspect-[4/3] shadow-sm border border-slate-100"
                        loading="lazy"
                    />
                </div>
            </div>
        </div>
    </section>
);
